export default {"turn":{"turn_number":1,"year":948,"season":0},"message_type":"TURN_STATE"}